import  api, { globalErrorHandler } from "../Api"

export const GET_MENU_ITEMS = "GET_MENU_ITEMS";
export const DELETE_MENU_ITEM = "DELETE_MENU_ITEM";
export const ADD_MENU_ITEM = "ADD_MENU_ITEM";
export const UPDATE_MENU_ITEM = "UPDATE_MENU_ITEM";
export const GET_MENU_ITEM_BYID = "GET_MENU_ITEM_BYID";
export const ME_LOADING = "ME_LOADING";
export const ME_ERROR = "ME_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetMenuItems = () => {
  
  return async dispatch => {
    dispatch({
      type: ME_LOADING
    });
    await api.get(`/HomeMenu`,config).then(res => 
      dispatch({
        type: GET_MENU_ITEMS,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetMenuItemById = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
    }  
  return async dispatch => {
    dispatch({
      type: ME_LOADING
    });
    await api.get(`/HomeMenu/${id}`,config).then(res => {
      dispatch({
        type: GET_MENU_ITEM_BYID,
        data: res.data
      });

      //console.log("categoriesaction", res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
      dispatch({
        type: ME_ERROR 
      })
    });
  };
};

export const AddMenuItem = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: ME_LOADING
      });

      api.post(`/HomeMenu`, 
      payload, config).then(res => {
          dispatch({
              type: ADD_MENU_ITEM,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: ME_ERROR 
        })
      });
  };
};

export const UpdateMenuItem = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: ME_LOADING
      });

      api.put(`/HomeMenu`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_MENU_ITEM,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: ME_ERROR 
        })
      });
  };
};

export const DeleteMenuItem = (id) => dispatch => {
  dispatch({
      type: ME_LOADING
  });
  
  api.delete(`/HomeMenu/Delete/${id}`).then(res => {
      dispatch({
          type: DELETE_MENU_ITEM,
          payload: res.data
      });
  })
  .catch((error) => {
    globalErrorHandler(error);
    dispatch({
      type: ME_LOADING
    })
  });
};
